var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOilChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 16.875V5h9.25v.9a1.622 1.622 0 00-.125.624v2.314c0 .23.045.443.125.634v7.403h-9.25zm10.75-6.41v6.549c0 .752-.61 1.361-1.361 1.361H2.236c-.752 0-1.361-.61-1.361-1.361V4.86c0-.752.61-1.361 1.361-1.361h9.528c.73 0 1.325.574 1.36 1.296l2.95-1.073a1.625 1.625 0 012.008.8l.219.438c.335.67.168 1.483-.404 1.967l-3.722 3.15c-.319.27-.689.39-1.05.388zm0-1.5a.116.116 0 00.08-.031l3.723-3.15a.125.125 0 00.031-.152l-.219-.437a.125.125 0 00-.154-.062L13.125 6.39v2.573z",
    fill: "#e95832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.83 9.85l1.473 1.472a2.08 2.08 0 11-2.943 0l1.47-1.473z",
    stroke: "#e95832",
    strokeWidth: 1.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/oil_change.f6b4a469.svg";
export { SvgOilChange as ReactComponent };